import { Card, Button } from "antd";
import { Projects } from "@modules";
import { Breadcrumb } from "@components";
import { Link } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";

export default function ProjectsPage() {
  return (
    <div className="container max-content">
      <Breadcrumb data={[{ title: "Projects", href: "/projects" }]} />
      <div className="flex justify-between items-center flex-wrap mb-5">
        <h1 className="text-3xl">Projects</h1>
        <Link to="/projects/new">
          <Button className="m-0" icon={<PlusOutlined />} type="primary">
            Add New
          </Button>
        </Link>
      </div>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Card bordered={false}>
            <Projects.List />
          </Card>
        </div>
      </div>
    </div>
  );
}
